import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { publicRequest } from '../../requestMethods';
import './EditMosque.scss';
import MosqueLoader from '../../utils/MosqueLoader';
import Footer from '../Footer';
import Navbar from '../Navbar/Navbar';
import { useSnackbar } from '../../contexts/SnackbarContext';

const EditMosque = () => {
    const { mosqueID } = useParams();
    const navigate = useNavigate();
    const snackbar = useSnackbar();
    const [loading, setLoading] = useState(true);

    const [mosque, setMosque] = useState({
        name: '',
        district: '',
        state: 'Kerala',
        dish: '',
        status: 'available',
        googleMapsLink: '',
        location: {
            latitude: '',
            longitude: ''
        },
        description: '',
        keywords: [],
        verified: false
    });

    useEffect(() => {
        const fetchMosque = async () => {
            try {
                const response = await publicRequest.get(`/mosques/get-mosque/${mosqueID}`);
                setMosque(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching mosque:', error);
                setLoading(false);
            }
        };

        fetchMosque();
    }, [mosqueID]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('location.')) {
            const locationField = name.split('.')[1];
            setMosque(prev => ({
                ...prev,
                location: {
                    ...prev.location,
                    [locationField]: value
                }
            }));
        } else if (name === 'keywords') {
            setMosque(prev => ({
                ...prev,
                keywords: value.split(',').map(k => k.trim())
            }));
        } else {
            setMosque(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('user'));
        try {
            await publicRequest.put(`/mosques/update-mosque/${mosqueID}`, {
                ...mosque,
                user: user ? { email: user.email, googleId: user.googleId || user.sub } : null
            });
            snackbar.success('Mosque updated successfully!');
            // alert('Mosque updated successfully!');
            // navigate(`/mosque/${mosqueID}`);
        } catch (error) {
            console.error('Error updating mosque:', error);
            snackbar.error('Failed to update mosque');
            // alert('Failed to update mosque');
        } finally {
            setLoading(false);
        }
    };

    // if (loading) return <div className="edit-mosque">Loading...</div>;

    return (
        <>
            {loading && <MosqueLoader />}
            <Navbar />
            <div className="edit-mosque">
                <div className="edit-mosque__container">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        <ArrowLeft size={20} />
                        Back
                    </button>

                    <h1 className="edit-mosque__title">Edit Mosque Details</h1>
                    <div className="edit-mosque__id">ID: {mosqueID}</div>

                    <form onSubmit={handleSubmit} className="edit-mosque__form">
                        <div className="form-group">
                            <label>Mosque Name</label>
                            <input
                                type="text"
                                name="name"
                                value={mosque.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>District</label>
                                <input
                                    type="text"
                                    name="district"
                                    value={mosque.district}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>State</label>
                                <input
                                    type="text"
                                    name="state"
                                    value={mosque.state}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    name="status"
                                    value={mosque.status}
                                    onChange={handleChange}
                                >
                                    <option value="available">Available</option>
                                    <option value="unavailable">Not Available</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Verified</label>
                                <select
                                    name="verified"
                                    value={mosque.verified}
                                    onChange={handleChange}
                                >
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Dish</label>
                            <input
                                type="text"
                                name="dish"
                                value={mosque.dish}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Google Maps Link</label>
                            <input
                                type="text"
                                name="googleMapsLink"
                                value={mosque.googleMapsLink}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Latitude</label>
                                <input
                                    type="number"
                                    name="location.latitude"
                                    value={mosque.location.latitude}
                                    onChange={handleChange}
                                    step="any"
                                />
                            </div>

                            <div className="form-group">
                                <label>Longitude</label>
                                <input
                                    type="number"
                                    name="location.longitude"
                                    value={mosque.location.longitude}
                                    onChange={handleChange}
                                    step="any"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Keywords (comma-separated)</label>
                            <input
                                type="text"
                                name="keywords"
                                value={mosque.keywords.join(', ')}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>Description</label>
                            <textarea
                                name="description"
                                value={mosque.description}
                                onChange={handleChange}
                                rows="4"
                            />
                        </div>
                        <button type="submit" className="submit-button">
                            Save Changes
                        </button>
                    </form>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default EditMosque;